/**
 * Session 19d — OCPP 2.0.1 NotifyDisplayMessages (CP → CSMS): the paged
 * reply to an inbound GetDisplayMessages. v2.0.1-only.
 */
import { messageInfoToWire, type DisplayMessageSnapshot } from '@/domain/DisplayMessage';

export interface NotifyDisplayMessagesDomain {
  readonly requestId: number;
  readonly tbc: boolean;
  readonly messageInfo: readonly DisplayMessageSnapshot[];
}

export function buildNotifyDisplayMessagesRequest(
  req: NotifyDisplayMessagesDomain,
): Record<string, unknown> {
  return {
    requestId: req.requestId,
    tbc: req.tbc,
    // Empty messageInfo is omitted — the schema forbids an empty array.
    ...(req.messageInfo.length > 0
      ? { messageInfo: req.messageInfo.map(messageInfoToWire) }
      : {}),
  };
}

/**
 * Split a message set into paginated NotifyDisplayMessages payloads.
 * Empty input still yields one terminating page (no messageInfo field).
 */
export function paginateNotifyDisplayMessages(
  requestId: number,
  messages: readonly DisplayMessageSnapshot[],
  maxItemsPerPage: number,
): readonly NotifyDisplayMessagesDomain[] {
  const perPage = Math.max(1, Math.floor(maxItemsPerPage));
  if (messages.length === 0) {
    return [{ requestId, tbc: false, messageInfo: [] }];
  }
  const pages: NotifyDisplayMessagesDomain[] = [];
  for (let i = 0; i < messages.length; i += perPage) {
    pages.push({
      requestId,
      tbc: i + perPage < messages.length,
      messageInfo: messages.slice(i, i + perPage),
    });
  }
  return pages;
}
